
import instance from "./api";

const endpoints = {
  configuration: (projectId, sport) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/statistics/${sport}/configuration`,
  content: (projectId, sport, contentKey) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/statistics/${sport}/configuration/${contentKey}/content`,
  options: (projectId, competitionId) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/statistics/cricket/competitions/${competitionId}/options`,
  competitions: (projectId, sport) =>
    `${process.env.REACT_APP_API_URL}/api/projects/${projectId}/statistics/${sport}/competitions/by-filter`,
};

const fetchPointsTableConfiguration = async (projectId, sport, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.configuration(projectId, sport);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchPointsTableContent = async (projectId, sport, contentKey, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.content(projectId, sport, contentKey);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchCompetitionsOptions = async (projectId, competitionId, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.options(projectId, competitionId);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const fetchPointsTableCompetitions = async (projectId, sport, params) => {
  const queryParams = params
    ? params.map((x) => `${x.key}=${x.value}`).join("&")
    : "";
  const endpoint = endpoints.competitions(projectId, sport);
  const res = await instance.get(
    `${endpoint}${queryParams ? `?${queryParams}` : ""}`
  );
  return res.data;
};

const setPointsTableConfiguration = async (projectId, sport, data) => {
  const res = await instance.post(endpoints.configuration(projectId, sport), data);
  return res.data;
};

const setPointsTableContent = async (projectId, sport, contentKey, data) => {
  const res = await instance.put(endpoints.content(projectId, sport, contentKey), data);
  return res.data;
};

const setCompetitionsOptions = async (projectId, id, data) => {
  const res = await instance.post(endpoints.options(projectId, id), data);
  return res.data;
};

export {
  fetchPointsTableConfiguration,
  setPointsTableConfiguration,
  fetchCompetitionsOptions,
  fetchPointsTableContent,
  setPointsTableContent,
  fetchPointsTableCompetitions,
  setCompetitionsOptions,
};
